var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('v-chip',{attrs:{"small":"","text-color":_vm.value.text_color,"label":"","color":_vm.value.color}},[_vm._v("tag: "+_vm._s(_vm.value.name))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }